import { money } from "@/lib/format";
import type { Summary } from "@/lib/types";

interface Props {
  summary: Summary;
  businessName: string;
}

export default function SummaryHero({ summary, businessName }: Props) {
  const positive = summary.netProfit >= 0;
  return (
    <div className="overflow-hidden rounded-4xl border border-background-300/50 bg-gradient-to-br from-background-100 via-background-200 to-background-300 p-5 text-foreground-950 shadow-float">
      <div className="flex items-center justify-between">
        <p className="text-[13px] font-medium text-foreground-600">Ganancia neta estimada</p>
        <span className="flex items-center gap-1 rounded-full bg-background-50/80 px-2.5 py-1 text-[11px] font-medium text-foreground-700">
          <i className="ri-store-2-line text-xs" />
          {businessName}
        </span>
      </div>
      <p className="tabular-nums mt-2 text-[34px] font-bold leading-none text-foreground-950">
        {money(summary.netProfit, summary.currency)}
      </p>
      <p className="mt-1 text-[12px] text-foreground-500">
        {positive ? "Después de gastos y pérdidas" : "Resultado negativo del período"}
      </p>

      <div className="mt-5 grid grid-cols-2 gap-3">
        <div className="rounded-2xl bg-background-50/80 p-3">
          <div className="flex items-center gap-1.5 text-foreground-500">
            <i className="ri-arrow-down-line text-sm" />
            <span className="text-[11px] font-medium">Ingresos por ventas</span>
          </div>
          <p className="tabular-nums mt-1 text-[17px] font-semibold text-foreground-950">
            {money(summary.salesIncome, summary.currency)}
          </p>
        </div>
        <div className="rounded-2xl bg-background-50/80 p-3">
          <div className="flex items-center gap-1.5 text-foreground-500">
            <i className="ri-arrow-up-line text-sm" />
            <span className="text-[11px] font-medium">Ganancia bruta</span>
          </div>
          <p className="tabular-nums mt-1 text-[17px] font-semibold text-foreground-950">
            {money(summary.grossProfit, summary.currency)}
          </p>
        </div>
      </div>
    </div>
  );
}